import React from 'react'
import './ModuleLoader.scss'

const ModuleLoader = () => {
    return (
        <div className="loader-section">
            <div className="lds-roller">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
        </div>
    )
}

export default ModuleLoader
